"use client";

import { useEffect } from "react";

export function ConsoleErrorLoggerProvider({ children }) {
  useEffect(() => {
    const originalConsoleError = console.error;

    console.error = (...args) => {
      if (window?.clarity) {
        originalConsoleError.apply(console, args);
        window.clarity("set", "consoleError", args.join(" "));
      }
    };

    const errorHandler = (event) => {
      if (window?.clarity) {
        window.clarity("set", "error", event.message || "Unknown error");
      }
    };

    const rejectionHandler = (event) => {
      if (window?.clarity) {
        window.clarity("set", "unhandledRejection", event.reason?.toString() || "Unhandled rejection");
      }
    };

    window.addEventListener("error", errorHandler);
    window.addEventListener("unhandledrejection", rejectionHandler);

    return () => {
      console.error = originalConsoleError;
      window.removeEventListener("error", errorHandler);
      window.removeEventListener("unhandledrejection", rejectionHandler);
    };
  }, []);

  return children;
}

export default ConsoleErrorLoggerProvider;